// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"262":"page--common","443":"about"}[chunkId] + "." + {"262":"5fc2c25a","443":"6cafd8e6"}[chunkId] + ".css";
};